export const REACT_TYPEOF_KEY = '$$typeof';
export const COMPONENT_NAMESPACE = 'data-gc-component';
export const CONNECTED_NAMESPACE = 'data-gc-c16t';
export const CONTEXT_COMPONENT_NAMESPACE = 'data-gc-c5tc8t';

/**
 * Special key where the connected namespaces are stored.
 * This is attached to Context connected components as a static property.
 */
export const CONNECT_STATIC_NAMESPACE = '__contextSystemKey__';
